export default {
  kpis: [
    { label: 'Revenue', value: '$48,200', trend: 12 },
    { label: 'Orders', value: '1,240', trend: 5 },
    { label: 'Customers', value: '820', trend: 8 },
    { label: 'Refunds', value: '$1,200', trend: -3 },
  ],
  sales: Array.from({ length: 30 }, (_, i) => ({
    day: i + 1,
    value: 800 + Math.round(Math.random() * 400),
  })),
};

